import { Plus, Lock, ShieldCheck, Truck } from "lucide-react";
import { scrollToId } from "@/lib/lenis";

export default function Footer() {
    return (
        <footer data-testid="footer" className="bg-sage-hover text-cream/80">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
                <div>
                    <div className="flex items-center gap-2">
                        <span className="w-8 h-8 rounded-full bg-cream text-sage grid place-items-center">
                            <Plus size={16} strokeWidth={2.5} />
                        </span>
                        <span className="font-serif text-2xl font-semibold text-cream">Ergocox™</span>
                    </div>
                    <p className="mt-5 text-sm leading-relaxed text-cream/60 max-w-xs">
                        Le coussin ergonomique de précision médicale pour un soulagement immédiat du coccyx.
                    </p>
                </div>
                <div>
                    <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-cream/50">Navigation</h3>
                    <ul className="mt-5 flex flex-col gap-3 text-sm">
                        {[
                            ["manifeste", "Le Manifeste"],
                            ["benefices", "Bénéfices"],
                            ["anatomie", "Anatomie"],
                            ["offres", "Offres"],
                            ["faq", "FAQ"],
                        ].map(([id, label]) => (
                            <li key={id}>
                                <button
                                    data-testid={`footer-link-${id}`}
                                    onClick={() => scrollToId(id)}
                                    className="hover:text-terra transition-colors"
                                >
                                    {label}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <a data-testid="footer-link-suivi" href="/suivi" className="inline-block mt-1 text-sm hover:text-terra transition-colors">
                        Suivre ma commande
                    </a>
                </div>
                <div>
                    <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-cream/50">Garanties</h3>
                    <ul className="mt-5 flex flex-col gap-3 text-sm">
                        <li className="flex items-center gap-2.5"><Truck size={16} className="text-terra" /> Livraison suivie 8 à 12 jours</li>
                        <li className="flex items-center gap-2.5"><ShieldCheck size={16} className="text-terra" /> Satisfait ou Remboursé 30 jours</li>
                        <li className="flex items-center gap-2.5"><Lock size={16} className="text-terra" /> Paiement 100% sécurisé SSL 256-bit</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-cream/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/50">
                    <span data-testid="footer-copyright">© {new Date().getFullYear()} Ergocox™ — Tous droits réservés.</span>
                    <span className="flex items-center gap-3">
                        <a data-testid="footer-link-legal" href="/legal" className="hover:text-terra transition-colors">Mentions légales</a>
                        <a data-testid="footer-link-cgv" href="/legal" className="hover:text-terra transition-colors">CGV</a>
                        <a data-testid="footer-link-privacy" href="/legal" className="hover:text-terra transition-colors">Confidentialité</a>
                    </span>
                </div>
            </div>
        </footer>
    );
}
